import { forwardRef } from 'react';
import type { ButtonHTMLAttributes } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

const VARIANT_CLASSES: Record<ButtonVariant, string> = {
  primary: 'bg-accent text-[#070807] hover:bg-accent-hover',
  secondary: 'bg-surface-2 text-text-primary border border-border hover:bg-surface',
  danger: 'bg-[rgba(226,85,85,0.12)] text-[#f08484] border border-[rgba(226,85,85,0.35)]',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', className = '', type = 'button', ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={`inline-flex items-center justify-center gap-2 rounded-md px-4 py-2 text-sm font-medium
        transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-40
        ${VARIANT_CLASSES[variant]} ${className}`}
      {...props}
    />
  );
});
